/**
 * A product's address, with its name in it: /product/1/the-signature-tin.
 *
 * Owner-approved, 26 Sept 2026. The id stays first and is what the page loads
 * by, so the name part is decoration for people and search engines: an old
 * /product/1 link, or one whose name is out of date after a rename, still
 * opens the right tin, and the product page then corrects the address bar to
 * this form (see SingleProductComponent).
 *
 * scripts/seo-pages.mjs builds the same slug for the per-page HTML it writes -
 * keep the two rules identical.
 */
export function productSlug(title: string | null | undefined): string {
  return (title ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')   // é -> e
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function productPath(id: string | number, title?: string | null): string {
  const slug = productSlug(title);
  return slug ? `/product/${id}/${slug}` : `/product/${id}`;
}
